export default "__VITE_ASSET__DtXx8YL___"